import { validator } from "LIB/validate-this";

export function validateSellerFields(values, form) {
  form.validate("seller_credit_percent").required();
}

export default function(values) {
  return validator(values, form => {
    validateSellerFields(values, form);
  });
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/shared/FormSections/SellersSection/validate.js